/**
 * Whether the page draws the 3D view (M288): `?render=off` in the address skips it, its renderer never made and its
 * graphics never loaded, for a browser without WebGL and for playtesting the game's management in any browser. Read from
 * the address alone each time the page opens: never saved, never remembered, and the default the 3D view.
 */
export type RenderMode = 'auto' | 'off';

export function renderModeOf(search: string): RenderMode {
  return new URLSearchParams(search).get('render') === 'off' ? 'off' : 'auto';
}

/** The notice where the 3D view could not start (the brief's own words). */
export const NO_3D_NOTICE = '3D view unavailable in this browser. You can still manage your conservancy.';
/** The notice where the 3D view was turned off in the address. */
export const OFF_3D_NOTICE = 'The 3D view is off (render=off in the address). You can still manage your conservancy.';
/** The notice where the 3D view stopped while playing (a drawing error), the game going on. */
export const STOPPED_3D_NOTICE = 'The 3D view stopped working. You can still manage your conservancy.';
